import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { TextInput, useTranslate, useNotify, useRedirect, BooleanInput, SelectInput } from 'react-admin'
import { Grid, Tabs, Tab, Box, Typography } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { SettingEmail } from 'src/components/pages/administration/work-unit/logic/SettingEmail'
import { ColorPIckerInput } from 'src/components/uiElements/fields/ColorPIckerInput'
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

export const Notification = ({ editMode = false }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const [value, setValue] = useState(0)
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label='basic tabs example'>
          <Tab label={'smtp'} {...a11yProps(0)} />
          <Tab label={translate('ra.field.setting_email')} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <Grid container spacing={3}>
          <EditInputsWrap label={translate('ra.field.bcc_email')} lg={12} md={12} xs={12}>
            <TextInput source='bcc_email' label={false} fullWidth multiline />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.transport')}>
            <TextInput source='smtp_config.transport' label={false} fullWidth />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.mailer_from')}>
            <TextInput source='smtp_config.mailer_from' label={false} fullWidth />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.mailer_host')}>
            <TextInput source='smtp_config.mailer_host' label={false} fullWidth />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.mailer_port')}>
            <TextInput source='smtp_config.mailer_port' label={false} fullWidth />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.mailer_user')}>
            <TextInput source='smtp_config.mailer_user' label={false} fullWidth />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.mailer_password')}>
            <TextInput source='smtp_config.mailer_password' label={false} fullWidth />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.use_tls')}>
            <BooleanInput label={translate('ra.field.use_tls')} source='smtp_config.use_tls' fullWidth />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.use_ssl')}>
            <BooleanInput label={translate('ra.field.use_ssl')} source='smtp_config.use_ssl' fullWidth />
          </EditInputsWrap>
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Grid container spacing={3} marginY={'10px'}>
          <EditInputsWrap label={translate('ra.field.primary_color')} tooltiptext={'color para el email'}>
            <ColorPIckerInput source='primary_color' fullWidth />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.secondary_color')} tooltiptext={'color para el email'}>
            <ColorPIckerInput source='secondary_color' fullWidth />
          </EditInputsWrap>
        </Grid>
        <Grid container spacing={3}>
          <EditInputsWrap label={translate('ra.field.folder_root')} lg={4} md={4} xs={5}>
            <TextInput source={`folder`} label={false} fullWidth placeholder='src/emails/...' />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.liquidation_type')} lg={4} md={4} xs={5}>
            <SelectInput
              source={`liquidation_type`}
              label={false}
              fullWidth
              optionText={'name'}
              optionValue='value'
              choices={[
                {
                  name: 'Liquidación Mayorista',
                  value: 'liquidation_wholesaler',
                },
                {
                  name: 'Liquidación Minorista',
                  value: 'liquidation_retail',
                },
                {
                  name: 'Liquidación Proveedor',
                  value: 'liquidation_supplier',
                },
              ]}
            />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.due_date')} lg={4} md={4} xs={5}>
            <BooleanInput source={`due_date`} label={false} fullWidth defaultValue={editMode ? false : true} />
          </EditInputsWrap>
        </Grid>
        <SettingEmail />
      </CustomTabPanel>
    </Box>
  )
}
